import { put, takeEvery, all, call, select } from 'redux-saga/effects';
import * as constants from '../constants/coursePage';
import * as coursePageActions from '../actions/coursePage';
import { MessageState } from '../../models/components/announcement.d';
import { Log } from 'ng2-logger';
import { CoursePageService } from '../../api/course-page-service';
import { Notification } from '../../components/notification/main';
import Translator from '../../core/i18n';
import * as coreActions from '../actions/core';
import { CourseContentMenuType } from '../../models/enums/CourseContentMenuType';
import { ISelect } from '../../models/core/system-model';
import { CacheService } from '../../core/cacheService';
import { IActionRequestDate } from '../../models/core/action-request';
import { IActivityCard } from '../../models/components/activity-card';
import { GetActivitiesType } from '../../models/enums/GetActivityType';
import ICourseContentTermWeeks from '../../models/components/course-content-termweeks';
import { IActivityFilters } from '../../models/action/coursePage';
import { ICourseContentWeekActivitesBody } from '../../models/components/course-content-weekactivities';
import queryString from 'querystring';
import Moment from 'moment';
import { CourseDefaultViewType } from '../../models/enums/CourseDefaultViewType';

const _lodash = require('lodash');
const T = Translator.create();
const _logger = Log.create('coursePage Saga');
const coursePageService = new CoursePageService();
const _cacheService = new CacheService();
const getCoursePageState = (state: { coursePage: any; }) => state.coursePage;

//#region "Course Page Main Saga"
function* setCoursePageData(params: any) {
    if (params.classId === 'null') {
        const classes: ISelect[] = yield coursePageService
            .RequestCourseClasses(params.activityId, 1, 0, '')
            .then((responseData: ISelect[]) => {
                return responseData;
            });
        if (classes.length === 1) {
            params.classId = classes[0].value;
        }

    }
    yield put(
        coursePageActions.setCoursePageData(
            params.activityId,
            params.classId,
            params.homePageSelectedTab,
            params.actId,
            params.weekOrUnitId
        )
    );
}

export function* watchGetCoursePageData() {
    yield takeEvery(constants.actions.GET_COURSE_PAGE_DATA, setCoursePageData);
    return null;
}

function* setCourseClassesData(params: any): any {
    try {
        const response = yield coursePageService
            .RequestCourseTeacherAndStudentClasses(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(coursePageActions.setCourseClassesData(response, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coursePageActions.setCourseClassesData(null, '', 'set'));
    }
    return null;
}

export function* watchSetCourseClassesData() {
    yield takeEvery(constants.actions.GET_COURSE_CLASSES_DATA, setCourseClassesData);
    return null;
}

//#endregion "End Course Page Main Saga"

//#region "Course Page Main Header Information"
function* setCoursePageHeaderInfoData(params: any): any {
    try {
        const nullData = { courseDescription: null, courseName: null, logoUrl: null, programName: null, teacher: null, teachers: null, isWeekly: null, startDate: null, endDate: null, classId: null, classDescription: null, activityViewType: null, courseDefaultView: null };
        yield put(coursePageActions.setCoursePageHeaderInformationData(nullData, [], false));

        const pageData = yield call(
            coursePageService.RequestGetCoursePageHeaderInfoAsync,
            params.classId,
            params.activityId
        );

        yield put(
            coursePageActions.setCoursePageHeaderInformationData(
                pageData,
                pageData && pageData.teacher ? pageData.teacher : [],
                true,
                params.spinnerId,
                'set'
            )
        );
        if (params.callback) {
            params.callback();
        }
        // tslint:disable-next-line: no-empty
    } catch (error: any) { }
    return null;
}

export function* watchGetCoursePageHeaderInfoData() {
    yield takeEvery(constants.actions.GET_COURSE_PAGE_HEADERINFORMATOIN_DATA, setCoursePageHeaderInfoData);
    return null;
}
//#endregion "End Course Page Main Header Information"

//#region "Course Class Activity Progress"
function* setClassActivityProgress(params: any): any {
    try {
        yield put(coursePageActions.setCourseClassActivityProgress(false, null));
        const pageData = yield coursePageService
            .RequestClassActivityProgressAsync(params.classId)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                return data;
            });

        yield put(coursePageActions.setCourseClassActivityProgress(true, pageData, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coursePageActions.setCourseClassActivityProgress(true, null));
        const empty: any = null;
    }
    return null;
}

export function* watchGetClassActivityProgressData() {
    yield takeEvery(constants.actions.GET_COURSE_CLASS_ACTIVITY_PROGRESS_DATA, setClassActivityProgress);
    return null;
}
//#endregion "End Course Class Activity Progress"

//#region "Course Page Change Class Saga"
function* setCoursePageChangeClassData(params: any) {
    yield put(coursePageActions.setCourseChangeClass(params.coursePageClassId));
    if (params.callBack) {
        setTimeout(() => {
            params.callBack();
        }, 500);
    }
}

export function* watchGetCoursePageChangeClassData() {
    yield takeEvery(constants.actions.GET_COURSE_PAGE_CHANGE_CLASS, setCoursePageChangeClassData);
    return null;
}
//#endregion "End Course Page Change Class Saga"

//#region "Course Page Home Selected Tab Saga"
function* setCoursePageSelectedData(params: any) {
    yield put(coursePageActions.setCoursePageSelectedTab(params.homePageSelectedTab));
}

export function* watchGetCoursePageSelectedTabData() {
    yield takeEvery(constants.actions.GET_COURSE_HOME_PAGE_SELECTED_TAB, setCoursePageSelectedData);
    return null;
}
//#endregion "End Course Page Home Selected Tab Saga"

//#region "Course Home Page Incoming Activities Saga"
function* setCourseIncomingActivitiesData(params: any): any {
    yield put(coursePageActions.setCoursePageIncomingActivities(null));
    try {
        const pageData = yield coursePageService
            .RequestIncomingActivitiesAsync(params.coursePageClassId)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(coursePageActions.setCoursePageIncomingActivities(pageData, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coursePageActions.setCoursePageIncomingActivities(null, params.spinnerId, 'set'));
    }
    return null;
}

export function* watchGetCoursePageIncomingActivitiesData() {
    yield takeEvery(constants.actions.GET_COURSE_PAGE_INCOMING_ACTIVITY, setCourseIncomingActivitiesData);
    return null;
}
//#endregion "End Course Home Page Incoming Activities"

//#region "Course Home Page Announcements Saga"
function* setCourseAnnouncementsData(params: any): any {
    try {
        yield put(coursePageActions.setCoursePageAnnouncementsAction(null, false));
        const pageData = yield coursePageService
            .RequestAnnouncementsAsync(params.coursePageClassId, params.coursePageActivityId, MessageState.Sent)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(coursePageActions.setCoursePageAnnouncementsAction(pageData, true, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coursePageActions.setCoursePageAnnouncementsAction(null, true));
    }
    return null;
}

export function* watchGetCoursePageAnnouncementsData() {
    yield takeEvery(constants.actions.GET_COURSE_PAGE_ANNOUNCEMENTS, setCourseAnnouncementsData);
    return null;
}

//#region "Course Home Page Current Week Activities Saga"
function* setCourseCurrentWeekActivitiesData(params: any): any {
    let isError = false;
    let errorList: any;

    try {
        yield put(coursePageActions.setCoursePageCurrentWeekSetAction(null, false));
        const pageData = yield coursePageService.RequestCurrentWeekActivitiesAsync(params.coursePageClassId)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            errorList
                ? Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                })
                : Notification.setNotification('error', T.t('r_course_page_lessonPage_currentWeek_activities_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(coursePageActions.setCoursePageCurrentWeekSetAction(pageData, true, params.spinnerId, 'set'));
        }

    } catch (error: any) {
        Notification.setNotification('error', T.t('r_course_page_lessonPage_currentWeek_activities_error_message') + error, 'topRight');
    }
}

export function* watchGetCoursePageCurrentWeekActivitiesData() {
    yield takeEvery(constants.actions.GET_COURSE_PAGE_CURRENT_WEEK_ACTIVITIES, setCourseCurrentWeekActivitiesData);
    return null;
}
//#endregion "End Course Home Page Current Week Activities"

//#region "Course page course contents weeks"
function* setCourseContentsWeeksData(params: any): any {
    try {
        yield put(coursePageActions.setCourseContentsWeeksAction(null, false));
        const pageData = yield coursePageService
            .RequestGetCourseContentsWeeksAsync(params.coursePageClassId)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(coursePageActions.setCourseContentsWeeksAction(pageData, true));
    } catch (error: any) {
        yield put(coursePageActions.setCourseContentsWeeksAction(null, true));
    }
    return null;
}

export function* watchGetCourseContentsWeeksData() {
    yield takeEvery(constants.actions.GET_COURSE_PAGE_COURSECONTENTS_WEEKS, setCourseContentsWeeksData);
    return null;
}
//#endregion "End Course page course contents weeks"

//#region "Course page course contents week activities"
function* setCourseContentsWeekActivitiesData(params: any): any {

    let isError = false;
    let errorList: any;
    try {
        const pageData = yield coursePageService
            .RequestGetCourseContentsWeeksActivitiesAsync(params)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_forum_page_forumthread_get_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(coursePageActions.setCourseContentsWeekActivitiesAction(pageData, params.activeTabGuid, params.spinnerId, 'set', params.isThisWeek, params.termWeekId));
            if (params.callback) {
                params.callback();
            }
        }
    } catch (error: any) {
        yield put(coursePageActions.setCourseContentsWeekActivitiesAction(null, null, params.spinnerId, 'set'));
        if (params.callback) {
            params.callback();
        }
    }
    return null;
}

export function* watchGetCourseContentsWeekActivitiesData() {
    yield takeEvery(
        constants.actions.GET_COURSE_PAGE_COURSECONTENTS_WEEKS_ACTIVITIES,
        setCourseContentsWeekActivitiesData
    );
    return null;
}
//#endregion "End Course page course contents week activities"

//#region "Course page Student List Tab"
function* getCourseStudentList(params: any): any {
    try {

        const coursePage = yield select(getCoursePageState);
            const pageData = yield coursePageService
                .RequestGetCourseStudentListAsync(params)
                .then((responseData: Response) => {
                    return responseData;
                })
                .then((data: any | null) => {
                    if (!data) {
                        return null;
                    } else {
                        return data;
                    }
                });
            yield put(coursePageActions.setCourseStudentList(pageData, params.activeTabGuid, params.spinnerId, 'set'));
       
    } catch (error: any) {
        yield put(coursePageActions.setCourseStudentList(null, null, params.spinnerId, 'set'));
    }
    return null;
}

export function* watchGetCourseStudentListData() {
    yield takeEvery(constants.actions.GET_COURSE_STUDENT_LIST, getCourseStudentList);
    return null;
}
//#endregion "End Course page Student List Tab"

//#region "Course page Files Tab"
function* getCourseFiles(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield put(coursePageActions.setCourseFiles(null, null));
        const pageData = yield coursePageService
            .RequestGetCourseFilesAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            })
            .then(response => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            errorList
                ? Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                })
                : Notification.setNotification('error', T.t('r_course_page_files_get_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(coursePageActions.setCourseFiles(pageData, params.activeTabGuid, params.spinnerId, 'set'));
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_course_page_files_get_error_message') + error, 'topRight');
        yield put(coursePageActions.setCourseFiles(null, null, params.spinnerId, 'set'));
    }

    return null;
}

export function* watchGetCourseFilesData() {
    yield takeEvery(constants.actions.GET_COURSE_FILES, getCourseFiles);
    return null;
}
//#endregion "End Course page Files Tab"

//#region "Course Class Activity Report"
function* getClassActivityReport(params: any): any {
    let isError = false;
    let errorList: any;

    try {
        yield put(coursePageActions.setCourseClassActivityReport(null));
        const result = yield coursePageService
            .RequestGetCourseClassActivityReportAsync(params)
            .then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_report_page_get_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(coursePageActions.setCourseClassActivityReport(result, params.spinnerId, 'set'));
        }
    } catch (error: any) {
        yield put(coursePageActions.setCourseClassActivityReport(null, params.spinnerId, 'set'));
    }
    return null;
}

export function* watchGetCourseClassActivityReportData() {
    yield takeEvery(constants.actions.GET_COURSE_CLASS_ACTIVITY_REPORT, getClassActivityReport);
    return null;
}
//#endregion "Course Class Activity Stats"

//#region "Course Assignment Grade Information"
function* getCourseAssignmentGradeInformation(params: any): any {
    try {
        yield put(coursePageActions.setAssignmentGradeInformation(null));
        const result = yield coursePageService
            .RequestAssignmentGradeInformation(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    Notification.setNotification('error', T.t('r_assignment_grade_information_error_message'), 'topRight');
                    return null;
                } else {
                    return data;
                }
            });
        yield put(coursePageActions.setAssignmentGradeInformation(result, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coursePageActions.setAssignmentGradeInformation(null, params.spinnerId, 'set'));
    }
    return null;
}

export function* watchGetCourseAssignmentGradeInformation() {
    yield takeEvery(constants.actions.GET_COURSE_ASSIGNMENT_GRADE_INFORMATION, getCourseAssignmentGradeInformation);
    return null;
}
//#endregion "Course Assignment Grade Information"

//#region "Course Assignment Grade Student List"
function* getCourseAssignmentGradeStudentList(params: any): any {
    try {
        const result = yield coursePageService
            .RequestAssignmentGradeStudentList(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!(data && data.results && data.results.length > 0) && params.query) {
                    Notification.setNotification('error', T.t('r_assignment_grade_student_list_isEmpty_message'), 'topRight');
                    return null;
                } else {
                    return data;
                }
            });
        yield put(coursePageActions.setAssignmentGradeStudentList(result, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coursePageActions.setAssignmentGradeStudentList(null, params.spinnerId, 'set'));
    }
    return null;
}

export function* watchGetCourseAssignmentStudentList() {
    yield takeEvery(constants.actions.GET_COURSE_ASSIGNMENT_STUDENT_LIST, getCourseAssignmentGradeStudentList);
    return null;
}
//#endregion "Course Assignment Grade Student List"

//#region "Course Assignment Grade Save Grade"
function* getCourseAssignmentSaveGrade(params: any): any {
    try {
        yield put(coursePageActions.setAssignmentGradeSaveGrade(null));
        const result = yield coursePageService
            .RequestAssignmentGradeSaveGrade(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    Notification.setNotification('error', T.t('r_assignment_grade_save_grade_error_message'), 'topRight');
                    return null;
                } else {
                    return data;
                }
            });
        yield put(coursePageActions.setAssignmentGradeSaveGrade(result, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coursePageActions.setAssignmentGradeSaveGrade(null, params.spinnerId, 'set'));
    }
    return null;
}

export function* watchGetCourseAssignmentSaveGrade() {
    yield takeEvery(constants.actions.GET_COURSE_ASSIGNMENT_SAVE_GRADE, getCourseAssignmentSaveGrade);
    return null;
}
//#endregion "Course Assignment Grade Student List"

//#region "Course Assignment Grade Download All Files"
function* getCourseAssignmentGradeDownloadAllFiles(params: any): any {
    try {
        yield put(coursePageActions.setAssignmentGradeDownloadAll(null));
        const result = yield coursePageService
            .RequestAssignmentGradeDownloadAllGrades(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(coursePageActions.setAssignmentGradeDownloadAll(result, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coursePageActions.setAssignmentGradeDownloadAll(null, params.spinnerId, 'set'));
    }
    return null;
}

function* getCourseBulkGrade(params: any): any {
    const result = yield coursePageService
        .RequestAssignmentBulkGrade(params)
        .then((responseData: Response) => {
            return responseData;
        })
        .then((data: any | null) => {
            if (!data) {
                return null;
            } else {
                return data;
            }
        }).catch(error => _logger.error('in getCourseBulkGrade', error));
}

function* getProgressPercent(params: any): any {
    try {
        const pageData = yield coursePageService
            .RequestGetProgressPercentAsync(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(coursePageActions.setProgressPercent(pageData, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coursePageActions.setProgressPercent(null, params.spinnerId, 'set'));
    }
    return null;
}
export function* watchGetProgressPercent() {
    yield takeEvery(constants.actions.GET_PROGRESS_PERCENT, getProgressPercent);
    return null;
}

export function* watchGetCourseAssignmentGradeDownloadAll() {
    yield takeEvery(constants.actions.GET_COURSE_ASSIGNMENT_DOWNLOAD_ALL, getCourseAssignmentGradeDownloadAllFiles);
    return null;
}
//#endregion "Course Assignment Grade Student List"

export function* watchGetCourseBulkGrade() {
    yield takeEvery(constants.actions.GET_COURSE_BULK_GRADE, getCourseBulkGrade);
    return null;
}

//#region "Course Class Activity Download"
function* getClassActivityReportDownload(params: any): any {
    try {
        yield put(coursePageActions.setClassActivityReportDownload(null));
        const result = yield coursePageService
            .RequestClassActivityReportDownload(params)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        yield put(coursePageActions.setClassActivityReportDownload(result, params.spinnerId, 'set'));
    } catch (error: any) {
        yield put(coursePageActions.setClassActivityReportDownload(null, params.spinnerId, 'set'));
    }
    return null;
}

export function* watchGetClassActivityReportDownload() {
    yield takeEvery(constants.actions.GET_COURSE_CLASS_ACTIVITY_REPORT_DOWNLOAD, getClassActivityReportDownload);
    return null;
}
//#endregion "Course Class Activity Stats"
//#region "Course contents  activities - activity card"
function* setCourseContentActivityCardsData(params: any): any {
    let isError = false;
    let errorList: any;
    let pageData: any;

    yield put(coursePageActions.setActivityFiltersAction(params.activityFilters));
    try {
        yield coursePageService
            .RequestGetActivityCardsAsync({
                ActivityId: params.ActivityId,
                ClassId: params.ClassId,
                CourseId: params.CourseId,
                GetActivityType: params.GetActivitiesType,
                Skip: params.Skip,
                Take: params.Take,
                TermWeekId: params.TermWeekId == 0 ? -1 : params.TermWeekId,
                ContextId: params.ContextId,
                GetOnlyPassiveList: params.GetOnlyPassiveList,//
                weekZero: params.weekZero,
                activityFilters: params.activityFilters
            })
            .then((response: Response) => {
                return response;
            }).then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                    return false;
                }
                else {

                    return response.json();
                }
            }).then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    pageData = responseData;
                }
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : yield put(coreActions.newNotification(T.t('r_api_gen_course_content_not_specified'), '', '', 'topRight', 'error'));
        }

        if (!isError) {
            yield put(coursePageActions.setCourseContentsActivityCardAction(true, pageData, params.spinnerId, 'set', params.spinnerIds ? params.spinnerIds : undefined));
            if (params.callback) {
                yield params.callback();
            }
        }
    } catch (error: any) {
        _logger.error('setCourseContentActivityCardsData ERROR', error);
        // yield put(coursePageActions.setCourseContentsActivityCardAction(true, null, params.spinnerId, 'set', params.spinnerIds ? params.spinnerIds : undefined));
    }
    return null;
}

export function* watchGetCourseContentsActivityCardsData() {
    yield takeEvery(constants.actions.GET_COURSE_PAGE_ACTIVITY_CARDS, setCourseContentActivityCardsData);
    return null;
}
//#endregion "End course contents  activities - activity card"

//#region "Delete document activity"

function setDeleteActivityDataCallBack(params: any) {
    if (params.projectActivityId) {
        if (params.courseContentWeekActivities.length > 0) {
            const filterActivity = params.courseContentWeekActivities.find((activity: any) => activity.activityId === params.projectActivityId);
            params.callback(filterActivity);
        }
    } else {
        let callBackParam = null;
        if (params.courseContentWeekActivities.length) {
            if (params.afterDeletedActivityIndex === undefined) {
                callBackParam = params.courseContentWeekActivities[0];
            } else {
                callBackParam = params.courseContentWeekActivities[params.afterDeletedActivityIndex];
            }
        }
        params.callback(callBackParam);
    }
}

function* setDeleteActivityData(params: any): any {
    let isError = false;
    let errorList: any;

    try {
        const pageData = yield coursePageService
            .RequestDeleteActivityAsync({
                ActivityId: params.activityId,
                ClassId: params.classId,
                CourseId: params.courseId,
                ActivityType: params.activityType,
            }).then((response: Response) => {
                if (response.status !== 200) {
                    isError = true;
                    return response.json();
                }
                return response;
            }).then((responseData: any) => {
                if (isError) {
                    errorList = responseData;
                } else {
                    return responseData;
                }
            });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_api_gen_activity_deleted_error_message'), 'topRight');
        } else {
            yield put(
                coursePageActions.setDeleteActivityAction(true, '', params.activityCard, false, false, params.courseContentWeekActivities)
            );
            yield put(coreActions.newNotification(T.t('r_gen_delete_success'), T.t('r_gen_success'), null, 'topRight', 'success'));

            if (pageData) {
                setDeleteActivityDataCallBack(params);

            }

            yield put(
                coursePageActions.setDeleteActivityAction(
                    false,
                    params.activityId,
                    params.activityCardItems,
                    true,
                    true,
                    params.courseContentWeekActivities,
                    params.spinnerId,
                    'set'
                )
            );
        }
    } catch (error: any) {
        yield put(
            coursePageActions.setDeleteActivityAction(
                false,
                params.activityId,
                params.activityCardItems,
                true,
                true,
                params.courseContentWeekActivities
            )
        );
    }
    return null;
}

export function* watchGetDeleteDocumentActivityData() {
    yield takeEvery(constants.actions.GET_COURSE_PAGE_DELETE_ACTIVITY, setDeleteActivityData);
    return null;
}
//#endregion "End delete document activity"

//#region "Survey Question and Choices"
function* setSurveyChoices(params: any): any {
    yield put(coursePageActions.setSurveyChoices(params.surveyChoices));
}

export function* watchGetSurveyChoicesData() {
    yield takeEvery(constants.actions.GET_SURVEY_CHOICES, setSurveyChoices);
    return null;
}
//#endregion "Survey Question and Choices"

//#region "Pages of My Courses"

function* setCourseContentMenuDataIsError(pageData: any, params: any, isError: any, errorList: any) {
    if (isError) {
        errorList ?
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            }) : Notification.setNotification('error', T.t('r_incoming_activities_error_message'), 'topRight');
        yield put(coursePageActions.setGettingWeeks(false));
    }
    else {
        yield put(coursePageActions.setCourseContentMenu(pageData.termWeeks, true, pageData.menuType, params.spinnerId, 'set'));
        if (params.callback) {
            params.callback(pageData.termWeeks);
        }

        yield put(coursePageActions.setGettingWeeks(false));
    }
}
function* setCourseContentMenuData(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield put(coursePageActions.setGettingWeeks(true));

        if (params.reset) {
            yield put(coursePageActions.setCourseContentMenu(null, false, null));
        } else {
            const pageData = yield coursePageService
                .RequestGetCourseContentMenuAsync({
                    ClassId: params.classId,
                    CourseId: params.courseId
                }).then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData.json();
                }).then((response) => {
                    if (isError) {
                        errorList = response;
                    } else {
                        return response;
                    }
                });
            yield setCourseContentMenuDataIsError(pageData, params, isError, errorList)

        }
    } catch (error: any) {
        yield put(coursePageActions.setCourseContentMenu(null, true, null));
        yield put(coursePageActions.setGettingWeeks(false));
    }
    return null;
}

function* setActivityIdsByWeeksData(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield put(coursePageActions.setGettingWeeks(true));

        if (params.reset) {
            yield put(coursePageActions.setActivityIdsByWeeks(null, false, null));
        } else {
            const pageData = yield coursePageService
                .RequestGetActivityIdsByWeeksAsync({
                    ClassId: params.classId,
                    IsCache: params.isCache,
                    CourseId: params.courseId
                }).then((responseData: Response) => {
                    if (responseData.status !== 200) {
                        isError = true;
                    }
                    return responseData.json();
                }).then((response) => {
                    if (isError) {
                        errorList = response;
                    } else {
                        return response;
                    }
                });

            if (isError) {
                errorList ?
                    Object.keys(errorList).forEach((key: any) => {
                        Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                    }) : Notification.setNotification('error', T.t('r_incoming_activities_error_message'), 'topRight');
                yield put(coursePageActions.setGettingWeeks(false));
            }

            if (!isError) {
                yield put(coursePageActions.setActivityIdsByWeeks(pageData.termWeeks, true, pageData.menuType, params.spinnerId, 'set'));
                if (params.callback) {
                    params.callback(pageData.termWeeks);
                }

                yield put(coursePageActions.setGettingWeeks(false));
            }
        }
    } catch (error: any) {
        yield put(coursePageActions.setActivityIdsByWeeks(null, true, null));
        yield put(coursePageActions.setGettingWeeks(false));
    }
    return null;
}

export function* watchGetCourseContentMenuData() {
    yield takeEvery(constants.actions.GET_COURSE_CONTENT_MENU, setCourseContentMenuData);
    return null;
}

export function* watchGetActivityIdsByWeeksData() {
    yield takeEvery(constants.actions.GET_ACTIVITY_IDS_BY_WEEKS, setActivityIdsByWeeksData);
    return null;
}

//#endregion "End Pages of My Courses"

function* getMyActivityStats(params: any): any {
    let isError = false;
    let errorList: any;
    const cacheData: IActionRequestDate = { firstRequestDate: new Date(), actionName: params.type };
    if (!_cacheService.CheckCache(cacheData)) {
        _cacheService.AddOrUpdateActionRequest(cacheData);
        try {
            const pageData = yield coursePageService.RequestGetMyActivityStastAsync().then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

            if (isError) {
                errorList ?
                    Object.keys(errorList).forEach((key: any) => {
                        Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                    }) : Notification.setNotification('error', T.t('r_course_page_my_activity_stats_error_message'), 'topRight');
            }

            if (!isError) {
                yield put(coursePageActions.getMyActivityStatsSetAction(pageData, params.spinnerId, 'set'));
            }
        } catch (error: any) {
            Notification.setNotification('error', T.t('r_course_page_my_activity_stats_error_message'), 'topRight');
        }
    } else {
        try {
            const pageData = yield coursePageService.RequestGetMyActivityStastAsync().then((responseData: Response) => {
                return responseData;
            }).then((responseData: Response) => {
                if (responseData.status !== 200) {
                    isError = true;
                }
                return responseData.json();
            }).then((response) => {
                if (isError) {
                    errorList = response;
                } else {
                    return response;
                }
            });

            if (isError) {
                errorList ?
                    Object.keys(errorList).forEach((key: any) => {
                        Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                    }) : Notification.setNotification('error', T.t('r_course_page_my_activity_stats_error_message'), 'topRight');
            }

            if (!isError) {
                yield put(coursePageActions.getMyActivityStatsSetAction(pageData, params.spinnerId, 'set'));
            }
        } catch (error: any) {
            Notification.setNotification('error', T.t('r_course_page_my_activity_stats_error_message'), 'topRight');
        }
    }

}

function* getActivityStatus(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        yield coursePageService.RequestGetActivityStatusAsync({ ActivityId: params.activityId, Status: params.status }).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData;
        }).then((data: any | null) => {
            if (!data) {
                return null;
            } else {
                return data;
            }
        });

        if (isError) {
            Notification.setNotification('error', T.t('r_activity_edit_unauthorized_error'), 'topRight');
        }
        else if (params.callback) {
            params.callback();
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_activity_edit_unauthorized_error'), 'topRight');
    }

}
export function* watchGetMyActivityStats() {
    yield takeEvery(constants.actions.GET_MY_ACTIVITY_STATS, getMyActivityStats);
    return null;
}
export function* watchGetActivityStatus() {
    yield takeEvery(constants.actions.SET_ACTIVITY_STATUS, getActivityStatus);
    return null;
}

const addClassListToButtons = () => {
    const movementButtons = document.getElementsByClassName('movement_buttons');
    if (movementButtons) {
        for (let i = 0; i < movementButtons.length; i++) {
            movementButtons[i].classList.add('d-none');
        }
    }
}

function* weekAndActivityStoryGetActivities(params: any, findWeek: any, weekZero: boolean, termWeekId: any, isWeekly: boolean): any {
    let itemGuid = '';
    if (!_lodash.isEqual(params.spinnerId, 'adding-spinner') && !_lodash.isEqual(params.sort, '-')) {
        params.activityFilters.sort = (!_lodash.isEmpty(params.sort)) ? params.sort : '';

    }

    if (findWeek?.itemGuid) {
        itemGuid = findWeek.itemGuid;
    }
    // yield getWeekActivities(findWeek.itemGuid!, weekZero, (termWeekId) ?? '0', isWeekly, params.courseContentTermWeeks, params.hasFilter, params.GetOnlyPassiveList, params.classId, params.courseId, params.sort, params.courseContentMenuType, params.activityFilters, params.courseContentWeekActivities, params.courseDefaultView, false);
    yield getWeekActivities(itemGuid, weekZero, (termWeekId) ?? '0', isWeekly, params.courseContentTermWeeks, params.hasFilter, params.GetOnlyPassiveList, params.classId, params.courseId, params.sort, params.courseContentMenuType, params.activityFilters, params.courseContentWeekActivities, params.courseDefaultView, false);

    if (!params.weekIdParam) {
        setTimeout(() => {
            const getScrollElement = document.getElementById('activities-tab');
            if (getScrollElement) {
                getScrollElement.scrollTop = 0;
            }
        }, 100);
    }

    if (findWeek) {
        const getCollElement = document.getElementById('collapse' + findWeek.itemGuid);
        if (getCollElement) {
            getCollElement.classList.add('collapse');
            getCollElement.classList.add('show');
        }
    }

}

function* callGetWeekClick(params: any, weekid: any): any {
    const findWeek = (params.courseContentTermWeeks as ICourseContentTermWeeks[]).find(x => x.termWeekId === weekid);
    if (findWeek && findWeek.termWeekId !== '0') {
        yield GetWeekClickActivities(findWeek.itemGuid!, true);
    }
}

const ifHasFilter = (weekid: any, params: any) => {
    if (weekid && params.hasFilter) {
        const itemPostisiton = document.getElementById('activitiesHeader' + weekid);
        const getScrollElement = document.getElementById('activities-tab');

        setTimeout(() => {
            if (itemPostisiton && getScrollElement && itemPostisiton.offsetTop) {
                getScrollElement.scrollTop = itemPostisiton.offsetTop - 55;
            }
        }, 100);
    }
}

function* weekOnClick(params: any): any {
    const weekid = params.weekIdParam ? params.weekIdParam : '';
    addClassListToButtons();

    if (params.courseContentTermWeeks) {

        const findWeek = (params.courseContentTermWeeks as ICourseContentTermWeeks[]).find(x => x.termWeekId === weekid);

        if (findWeek) {

            const termWeekId = (findWeek.week === null || findWeek.week === 0) ? '0' : findWeek.termWeekId;
            const weekZero = termWeekId == '0'
            const isWeekly = !findWeek.notWeekly;

            if (params.courseContentMenuType && params.courseContentMenuType === CourseContentMenuType.weekAndActivity) {
                yield getWeekActivities(findWeek.itemGuid!, weekZero, (termWeekId) ?? '0', isWeekly, params.courseContentTermWeeks, params.hasFilter, params.GetOnlyPassiveList, params.classId, params.courseId, params.sort, params.courseContentMenuType, params.activityFilters, params.courseContentWeekActivities, params.courseDefaultView, false);

            } else if (params.courseContentMenuType && params.courseContentMenuType === CourseContentMenuType.weekAndActivityStory) {
                yield weekAndActivityStoryGetActivities(params, findWeek, weekZero, termWeekId, isWeekly);
            }

        }
        else {
            const param = {
                actId: '',
                classId: params.classId,
                courseId: params.courseId,
                courseContentTermWeeks: params.courseContentTermWeeks,
                hasFilter: false,
                activityFilters: {
                    searchedText: '',
                    selectedActivityTypes: [],
                    sort: params.activityFilters.sort, // activityFiltersta da böyle geliyor
                    hasFilter: false,
                    GetOnlyPassiveList: false,
                },
                GetOnlyPassiveList: false,
                weekOrUnitId: '-1',
                courseContentMenuType: params.courseContentMenuType,
                sort: params.sort,
                activeStatus: -1,
                courseContentWeekActivities: params.courseContentWeekActivities,
                courseDefaultView: params.courseDefaultView,
                spinnerId: params.spinnerId
            };
            yield weekAndActivityStoryGetActivities(param, findWeek, false, "-1", true);

        }

        ifHasFilter(weekid, params);

        yield callGetWeekClick(params, weekid);
    }


}

function* getWeekActivities(tabGuid: string, weekZero: boolean, termWeekId: string, isWeekly: boolean, courseContentTermWeeks?: ICourseContentTermWeeks[], hasFilter?: boolean, GetOnlyPassiveList?: boolean, classId?: string, courseId?: string, sort?: string, courseContentMenuType?: CourseContentMenuType, activityFilters?: IActivityFilters, courseContentWeekActivities?: ICourseContentWeekActivitesBody[], courseDefaultView?: CourseDefaultViewType, isByPassActivityList: boolean = false) {
    if (!hasFilter) {
        if (courseContentTermWeeks) {
            // setTimeout(() => {
            const skip = 0;
            const take = 1000;
            const requestWeekZero = courseContentTermWeeks.length !== 1 ? weekZero : false;
            let tabGuidValue = 'contentWeekActivities'
            yield put(coursePageActions.SetIsClickedWeek(true, "SetIsClickedWeek", "set"));

            if (tabGuid) {
                tabGuidValue = 'getCourseContentsWeekActivitiesAction' + tabGuid;
            }
            yield put(coursePageActions.getCourseContentsWeekActivitiesAction(
                classId!,
                courseId!,
                isWeekly,
                skip,
                take,
                termWeekId,
                GetOnlyPassiveList!,
                requestWeekZero,
                tabGuid,
                tabGuidValue,
                'get',
                undefined,
                sort,
                yield searchActivityCardWeekClickAction(classId!, courseId!, termWeekId === '0' ? '-1' : termWeekId, courseContentTermWeeks, hasFilter, GetOnlyPassiveList, courseContentMenuType, activityFilters, courseContentWeekActivities, courseDefaultView)
            ));
            // }, 250);
        }
    }
}
function* scrollActivities() {

    setTimeout(() => {
        let search = window.location.search;
        search = search.replace('?', '');
        const params = queryString.parse(search);

        if (params.actid) {
            if (!('#week_activity_' + params.actid[0])) {
                $('.week_activity_show_more')
                setTimeout(() => scrollActivities(), 1000);
            } else {
                $('#week_activity_' + params.actid).click();
            }
        }
    }, 200);

}

function* searchActivityCardWeekClickAction(classId: string, courseId: string, termWeekId: string, courseContentTermWeeks?: ICourseContentTermWeeks[], hasFilter?: boolean, GetOnlyPassiveList?: boolean, courseContentMenuType?: CourseContentMenuType, activityFilters?: IActivityFilters, courseContentWeekActivities?: ICourseContentWeekActivitesBody[], courseDefaultView?: CourseDefaultViewType) {
    const param: IActivityCard = {
        actId: '',
        coursePageClassId: classId,
        coursePageActivityId: courseId,
        courseContentTermWeeks: courseContentTermWeeks!,
        hasFilter: hasFilter!,
        activityFilters: activityFilters!,
        GetOnlyPassiveList: GetOnlyPassiveList,
        weekOrUnitId: termWeekId,
        courseContentMenuType: courseContentMenuType!,
        courseContentWeekActivities: courseContentWeekActivities!
    };
    const nonWeeklyCourse = courseContentTermWeeks && courseContentTermWeeks.length === 1;
    yield put(coursePageActions.SetTriggerGetActivities(param, scrollActivities, "SetTriggerGetActivities", 'get', courseDefaultView, nonWeeklyCourse));

    //refresh activity count
    yield put(coursePageActions.getActivityIdsByWeeks(classId, '', false, 'getActivityIdsByWeeks', 'get', undefined, false, courseId ?? ""))
}

function* GetWeekClickActivities(itemKey: string, onlySelect?: boolean) {
    const getAllActiveClass = document.getElementsByClassName('courseContentWeekActive');
    const getWeekItemRootElement = document.getElementById('header' + itemKey);
    const getNonWeekElement = document.getElementById('headernonWeek');
    if (!onlySelect && getWeekItemRootElement && getWeekItemRootElement.classList.contains('courseContentWeekActive')) {

        if (getWeekItemRootElement) {
            getWeekItemRootElement.classList.remove('courseContentWeekActive');
        }
    } else {
        // tslint:disable-next-line:prefer-for-of
        for (let index = 0; index < getAllActiveClass.length; index++) {
            getAllActiveClass[index].classList.remove('courseContentWeekActive');
        }
        if (getWeekItemRootElement) {
            getWeekItemRootElement.classList.add('courseContentWeekActive');
        } else {
            if (getNonWeekElement) {
                getNonWeekElement.classList.add('courseContentWeekActive');
            }
        }
    }
}

export function* watchClickWeekActivities() {
    yield takeEvery(constants.actions.CLICK_WEEK_ACTIVITIES, weekOnClick);
    return null;
}

function* setUpdateInput(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const myYield = coursePageService.RequestUpdateInputAsync(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData;
        }).then((response) => {
            if (isError) {
                errorList = response;
            }
        });
        yield myYield;
        if (isError) {
            Object.keys(errorList).forEach((key: any) => {
                Notification.setNotification('error', T.t(errorList[key]), 'topRight');
            });
            yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        }

        if (!isError) {

            yield put(
                coreActions.newNotification(
                    T.t('r_gen_update_input'),
                    '',
                    '',
                    'topRight',
                    'success'
                )
            );
        }
        if (params.callback)
            params.callback();
    } catch (error: any) {
        yield put(coreActions.setSpinner(params.spinnerId, 'set'));
        Notification.setNotification('error', error, 'topRight');
    }
}

function* getActivityReportDetail(params: any): any {
    let isError = false;
    let errorList: any;
    try {
        const pageData = yield coursePageService.RequestGetActivityReportDetail(params).then((responseData: Response) => {
            return responseData;
        }).then((responseData: Response) => {
            if (responseData.status !== 200) {
                isError = true;
            }
            return responseData.json();
        }).then((response) => {
            if (isError) {
                errorList = response;
            } else {
                return response;
            }
        });

        if (isError) {
            errorList ?
                Object.keys(errorList).forEach((key: any) => {
                    Notification.setNotification('error', T.t(errorList[key]), 'topRight');
                }) : Notification.setNotification('error', T.t('r_course_page_my_activity_stats_error_message'), 'topRight');
        }

        if (!isError) {
            yield put(coursePageActions.ActivityReportDetailSetAction(pageData, params.spinnerId, 'set'));
        }
    } catch (error: any) {
        Notification.setNotification('error', T.t('r_course_page_my_activity_stats_error_message'), 'topRight');
    }
}


function*
    searchActivityCard(params: any): any {

    let getActivitiesType: GetActivitiesType;
    if (params.searchData.courseContentMenuType === CourseContentMenuType.week || params.searchData.courseContentMenuType === CourseContentMenuType.weekAndActivityStory) {
        getActivitiesType = GetActivitiesType.Week;
    } else if (params.searchData.courseContentMenuType === CourseContentMenuType.weekAndActivity) {
        getActivitiesType = GetActivitiesType.Activity;
    } else {
        getActivitiesType = GetActivitiesType.Course;
    }

    const coursePage = yield select(getCoursePageState);

    if (coursePage.classes?.classes?.length <= 0) {
        getActivitiesType = GetActivitiesType.Course;

    }

    // This code decides if the weekZero item is true or false.
    const hasActivityFilters = params.searchData.activityFilters?.hasFilter;
    const isNonWeeklyCourse = params.nonWeeklyCourse;
    const hasValidWeekOrUnitId = (params.searchData.weekOrUnitId !== '0' && params.searchData.weekOrUnitId !== '-1');
    const isDefaultViewList = params.courseDefaultView && params.courseDefaultView === CourseDefaultViewType.List;

    let shouldGetOnlyPassiveList = false;
    if (params.courseDefaultView !== null && params.courseDefaultView !== CourseDefaultViewType.List) {
        if (!hasActivityFilters && !isNonWeeklyCourse && !hasValidWeekOrUnitId && !isDefaultViewList) {
            shouldGetOnlyPassiveList = true
        }
    }

    yield put(coursePageActions.getCourseContentsActivityCardAction(
        getActivitiesType,
        params.searchData.coursePageClassId,
        params.searchData.coursePageActivityId,
        (params.searchData.actId) ? params.searchData.actId : '',
        !(params.courseDefaultView && params.courseDefaultView === CourseDefaultViewType.List) ? params.searchData.weekOrUnitId : '-1',
        201,
        0,
        'spinnerIdWeekA',
        'get',
        undefined,
        params.searchData.GetOnlyPassiveList,
        shouldGetOnlyPassiveList,
        params.activeStatus,
        params.callback,
        params.searchData.activityFilters
    ));
}

function* setTriggerCourseStar(params: any): any {
    try {
        const response = yield coursePageService
            .RequestTriggerCourseStar({ CourseId: params.CourseId })
            .then((responseData: Response) => {
                return responseData;
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
        params.callback();
    } catch (error: any) {
    }
    return null;
}

function* setTriggerRemovePrerequisite(params: any): any {
    try {
        const response = yield coursePageService
            .RequestRemovePrerequisite(params)
            .then((responseData: Response) => {
                if (responseData && responseData.status === 200) {

                    params.callback();
                    return responseData.json();
                } else {
                    return null;
                }
            })
            .then((data: any | null) => {
                if (!data) {
                    return null;
                } else {
                    return data;
                }
            });
    } catch (error: any) {
    }
    return null;
}

export function* watchSetTriggerCourseStar() {
    yield takeEvery(constants.actions.SET_TRIGGER_COURSE_STAR, setTriggerCourseStar);
    return null;
}

export function* watchUpdateInput() {
    yield takeEvery(constants.actions.SET_UPDATE_INPUT, setUpdateInput);
    return null;
}

export function* watchSearchActivityCard() {
    yield takeEvery(constants.actions.SET_TRIGGER_GET_ACTIVITIES_ACTION, searchActivityCard);
    return null;
}

export function* watchGetActivityReportDetail() {
    yield takeEvery(constants.actions.ACTIVITY_REPORT_DETAIL_GET_ACTION, getActivityReportDetail);
    return null;
}
export function* watchSetTriggerRemovePrerequisite() {
    yield takeEvery(constants.actions.SET_TRIGGER_REMOVE_PREREQUISITE, setTriggerRemovePrerequisite);
    return null;
}

export function* CoursePageSagas() {
    yield all([
        watchGetCoursePageData(),
        watchGetClassActivityProgressData(),
        watchGetCoursePageChangeClassData(),
        watchGetCoursePageSelectedTabData(),
        watchGetCoursePageIncomingActivitiesData(),
        watchGetCoursePageAnnouncementsData(),
        watchGetCoursePageCurrentWeekActivitiesData(),
        watchGetCourseContentsWeeksData(),
        watchGetCourseContentsWeekActivitiesData(),
        watchGetCourseContentsActivityCardsData(),
        watchGetDeleteDocumentActivityData(),
        watchGetSurveyChoicesData(),
        watchGetCourseContentMenuData(),
        watchGetActivityIdsByWeeksData(),
        watchGetCourseStudentListData(),
        watchGetCourseFilesData(),
        watchGetCourseClassActivityReportData(),
        watchGetClassActivityReportDownload(),
        watchGetCourseAssignmentGradeInformation(),
        watchGetCourseAssignmentStudentList(),
        watchGetCourseAssignmentSaveGrade(),
        watchGetCourseAssignmentGradeDownloadAll(),
        watchGetMyActivityStats(),
        watchGetActivityStatus(),
        watchUpdateInput(),
        watchGetProgressPercent(),
        watchGetActivityReportDetail(),
        watchSearchActivityCard(),
        watchClickWeekActivities(),
        watchSetCourseClassesData(),
        watchSetTriggerCourseStar(),
        watchSetTriggerRemovePrerequisite()
    ]);
}
